<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formPriceList">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" routerLink='/price-list' [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deletePriceList()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'"
                [width]="'5.5rem'" [icon]="'pi pi-plus'" [variant]="undefined"
                (onClick)="createNewPriceList()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="priceListContract.userNameCreate"
                [createDate]="priceListContract.createDate" [userNameUpdate]="priceListContract.userNameUpdate"
                [updateDate]="priceListContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="row">
              <div class="row col-lg-12">
                <div class="col col-sm-auto field-branch">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)">
                  </app-custom-select>
                </div>
                <div class="col field-code">
                  <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeCode()"></app-custom-input-number>
                </div>
                <div class="col field-alter-code">
                  <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                    [maxLength]="10"></app-custom-input-text>
                </div>
                <div class="col field-name">
                  <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true"
                    [maxLength]="70"></app-custom-input-text>
                </div>
                <div class="col field-discount">
                  <app-custom-input-decimal formControlName="rateDiscount" [labelText]="'Descuento'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col field-observation">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [maxLength]="250"></app-custom-textarea>
                </div>
                <div class="col save-button  d-flex justify-content-end align-items-end mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    (onClick)="send()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2  container-style ">
    <app-price-list-detail [priceListModel]="priceListContract" [permissionUpdatable]="permissionUpdatable"
      [disabledDetail]="disabledDetail"></app-price-list-detail>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>